import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../styles/DashboardStyling/ProjectDropdown.css";

const ProjectDropdown = ({
  userData,
  selectedSponsor,
  selectedProject,
  setSelectedProject,
  projects,
  setProjects,
}) => {
  // const [projects, setProjects] = useState([]);
  const [filteredProjects, setFilteredProjects] = useState([]);

  // Fetch projects once on component mount
  // useEffect(() => {
  //   fetchProjects();
  // }, []);

  // Reset project selection when sponsor changes
  useEffect(() => {
    setSelectedProject("All");
  }, [selectedSponsor, setSelectedProject]);

  // Filter after projects load or sponsor changes
  useEffect(() => {
    if (projects.length > 0) {
      filterProjects();
    }
  }, [selectedSponsor, userData, projects]);

  // const fetchProjects = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${process.env.REACT_APP_BACKEND_URL}/api/projects`
  //     );
  //     if (response.data.success) {
  //       setProjects(response.data.projects || []);
  //     } else {
  //       console.error("❌ API returned success=false:", response.data.message);
  //     }
  //   } catch (error) {
  //     console.error("❌ Error fetching projects:", error);
  //   }
  // };

  const isRestrictedRole = (role) => {
    return ["Sponsor", "Board Member"].includes(role);
  };

  const getAllowedProjects = () => {
    if (!userData || !userData.Role) {
      console.error("❌ No userData or role found:", userData);
      return [];
    }

    const userRoles = userData.Role;
    if (!Array.isArray(userRoles)) {
      console.error("❌ Invalid userRoles format:", userRoles);
      return [];
    }

    let allowedProjects = projects;

    // If user has a restricted role, filter only projects linked to their assigned sponsors
    if (userRoles.some((role) => isRestrictedRole(role))) {
      allowedProjects = projects.filter(
        (project) =>
          project.sptag &&
          project.sptag.some((tag) => userData.Company.includes(tag))
      );
    }
    return allowedProjects;
  };

  const filterProjects = () => {
    let allowedProjects = getAllowedProjects();
    if (selectedSponsor === "All") {
      setFilteredProjects(allowedProjects);
    } else {
      const filtered = allowedProjects.filter(
        (project) => project.sptag && project.sptag.includes(selectedSponsor)
      );
      setFilteredProjects(filtered);
    }
  };

  const handleProjectChange = (event) => {
    setSelectedProject(event.target.value);
  };

  return (
    <div className="project-dropdown">
      <label className="dropdown-label">Project:</label>
      <select
        className="dropdown"
        value={selectedProject}
        disabled={selectedSponsor === "All"}
        onChange={handleProjectChange}
      >
        <option value="All">All</option>
        {filteredProjects.map((project) => (
          <option
            className="dropdown-list"
            key={project.pid}
            value={project.pname}
          >
            {project.pname}
          </option>
        ))}
      </select>
    </div>
  );
};

export default ProjectDropdown;
